module.exports = require("npm:async.util.parallel@0.5.2/index.js");